export const DialogDuplicateAssignmentLabels = {
  driverWarning: 'Los siguientes choferes están asignados a más de un viaje:',
  primaryButton: 'Continuar',
  questionConfirm: '¿Deseas continuar con la importación?',
  secondaryButton: 'Cancelar',
  title: 'Atención',
  vehicleWarning: 'Los siguientes vehículos están asignados a más de un viaje:'
};
